<template>
  <div>
    <b-button @click="show=true" variant="primary">Passwort ändern</b-button>

    <b-modal
      no-close-on-backdrop
      centered
      v-model="show"
      title="Passwort ändern"
    >
      <b-container fluid>
        <b-row class="mb-1">
          <b-col cols="6">Altes Passwort</b-col>
          <b-col>
        <b-input
            v-model="form.oldPassword"
            required
            type="password"
            class="form-control"
          />
          </b-col>
        </b-row>

        <b-row class="mb-1">
          <b-col cols="6">Neues Passwort</b-col>
          <b-col>
        <b-input
            v-model="form.newPassword1"
            required
            type="password"
            class="form-control"
            name="password"
          />
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">Passwort wiederholen</b-col>
          <b-col>
        <b-input
            v-model="form.newPassword2"
            required
            type="password"
            class="form-control"
            name="password"
          />
          </b-col>
        </b-row>
        <b-row>
        <b-col cols="12">
        Hinweis: Du wirst nach Änderung des Passworts aufgefordert, Dich neu einzuloggen.
        </b-col>
        </b-row>
         <b-row>
          <b-col cols="12">
          <b-alert :show="message!=null" variant="danger">{{message}}</b-alert>
          </b-col>
        </b-row>
      </b-container>

      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            @click="show=false"
          >
            Schliessen
          </b-button>
          <b-button
            variant="primary"
            size="sm"
            class="float-right mr-2"
            @click="changePassword()"
          >Passwort ändern</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import api from '@/api/benutzer'
import { mapActions } from 'vuex'

export default {
  name: 'PasswordChange',
  props: ['user'],
  methods: {
    ...mapActions(['LogOut']),
    async changePassword () {
      let result = await api.changePassword(this.user.id, this.form)
      if (result.errorMessage) {
        this.message = result.errorMessage
      } else {
        this.message = null
        await this.LogOut()
        this.$bubble('logout')
        this.$router.push('/login')
      }
    }
  },
  watch: {
    show: function (oldValue, newValue) {
      if (!newValue) {
        this.message = null
      }
    }
  },
  data () {
    return {
      message: null,
      show: false,
      form: {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/main/vue/components/partials/PasswordChange.vue